import { FC, ReactNode } from 'react';
import { Button } from 'rsuite';
import classnames from 'classnames';
import { TypeAttributes } from 'rsuite/esm/internals/types';
import styles from './tag.module.scss';

interface RsTagProps {
  label: ReactNode;
  color?: TypeAttributes.Color;
  size?: TypeAttributes.Size;
  className?: string;
}

export const RsCreativeBindingStateTag: FC<RsTagProps> = ({
  label,
  size = 'md',
  color,
  className,
}) => {
  return (
    <Button
      appearance={'primary'}
      color={color}
      size={size}
      classPrefix='binding-tag'
      className={classnames(styles.RsBindingTag, className)}
      as={'div'}
    >
      {label}
    </Button>
  );
};
